import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PrivacyPage } from "./pages/privacy-page";
import "./index.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element (#root) was not found in privacy.html.");
}

createRoot(rootElement).render(
  <StrictMode>
    <PrivacyPage />
  </StrictMode>,
);
